import { useState, useEffect } from 'react';
import { Box } from '@mui/material';
import {
  CRUD_COMPONENT_TYPE,
  CRUDComponent,
  useDataProvider,
  useLocalization,
} from '@ui-framework/index';
import { nanoid } from 'nanoid';
import Grid2 from '@thirdparty-framework/mui/material/Grid';
import { observer } from 'mobx-react';
import {
  IconLibrary,
  StackablePageButtons,
  PageSection,
} from '@product-framework/index';
import { GenerateApiKeyDialog } from '@product-framework/components/Dialogs';
import {
  APIKey,
  isActive,
  createdDateTime,
  expiresAt,
  description,
  lastModifiedDateTime,
  buttonActions,
  lastModifiedBy,
  UserRole,
} from './accessorFunctions';
import listSchema from './list.json';
import RevokeApiKeyModal from './RevokeApiKeyModal';

function APIKeySettings({ serviceProviderId: pageId }) {
  const { formatMessage, messages } = useLocalization();
  const [open, setOpen] = useState(false);
  const [revokeObj, setRevokeObj] = useState(null);
  const [stackAblePageButtons, setStackAblePageButtons] = useState([]);
  const [listId, setListId] = useState(nanoid());

  const provider =
    process.env.NODE_ENV === 'development' ? 'sxclServices' : 'default';
  const dataProvider = useDataProvider(provider);
  const listApiUrl = `${dataProvider.getApiUrl()}/sxcl/v1/service-providers/${pageId}/api-key`;

  const createButton = {
    label: formatMessage({
      id: 'CREATE_NEW_USER_STACKABLE_BUTTON',
      defaultMessage: 'Create Key',
    }),
    Icon: IconLibrary.ApiKey,
    permissionName: 'CAN_CREATE_SP_API_KEY',
    variant: 'outlined',
    onClick: () => {
      setOpen(true);
    },
  };

  const openRevokeModal = apikeyObj => {
    setRevokeObj(apikeyObj);
  };

  const listProps = {
    columnPrimaryId: 'id',
    storeName: 'ServiceProviderAPIKeySettings',
    dataProvider,
    schema: listSchema,
    initialState: {
      showColumnFilters: false,
    },
    downloadApiUrl: null,
    listApiUrl,
    accessorFunctions: {
      APIKey,
      UserRole,
      isActive,
      createdDateTime,
      expiresAt,
      description,
      lastModifiedDateTime,
      buttonActions,
      lastModifiedBy,
    },
    accessorFunctionsAdditional: {
      openRevokeModal,
    },
    sortBy: 'createdDateTime',
    sortOrder: 'ASC',
  };

  useEffect(() => {
    const buttons = [];
    buttons.push(createButton);
    setStackAblePageButtons(buttons);
  }, [messages]);

  return (
    <PageSection
      HeaderContent={
        <StackablePageButtons
          backButton={false}
          buttons={stackAblePageButtons}
        />
      }
      label={formatMessage({
        id: 'SERVICE_PROVIDER_API_KEYS_HEADING',
        defaultMessage: 'Api Keys',
      })}>
      <Grid2 container direction="column" spacing={2}>
        <Box>
          <CRUDComponent
            key={listId}
            type={CRUD_COMPONENT_TYPE.ADVANCED_LIST}
            listProps={listProps}
          />
        </Box>
      </Grid2>
      <GenerateApiKeyDialog
        open={open}
        serviceProviderId={pageId}
        onClose={() => setOpen(false)}
        reRenderList={() => {
          setListId(nanoid());
        }}
      />
      {revokeObj && (
        <RevokeApiKeyModal
          record={revokeObj}
          close={() => {
            setRevokeObj(null);
            setListId(nanoid());
          }}
          serviceProviderId={pageId}
        />
      )}
    </PageSection>
  );
}

export default observer(APIKeySettings);
